import {
  internalNewProductCard,
  newProductCard
} from './constants/signalmanConstants';

export const newProductCardEnabled = () => {
  return newProductCard === 'test';
};

export const internalNewProductCardEnabled = () => {
  return internalNewProductCard === 'test';
};

export const useNewProductCard = (internalCatalog) => {
  return internalCatalog
    ? internalNewProductCardEnabled()
    : newProductCardEnabled();
};
